interface DownloadIconProps {
  color?: string;
  width?: string;
  height?: string;
  className?: string;
}

const DownloadIcon = ({
  color = 'currentColor',
  width = '16',
  height = '16',
  className = '',
}: DownloadIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    {/* Arrow stem */}
    <path
      d="M8 2v7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Arrow head (downward) */}
    <path
      d="M4 8l4 4 4-4"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Tray / base line */}
    <path
      d="M2 13h12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default DownloadIcon;
